import { dataIdCard } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIdCard = /*#__PURE__*/createIcon(dataIdCard)
export default IconIdCard
